<template>
    <label class="form-checkbox">
        <input
            type="checkbox"
            :checked="model"
            @input="(event) => $emit('update:modelValue', event.target.checked)"
        />

        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24">
            <rect
                class="form-checkbox-square"
                width="24"
                height="24"
                rx="3" />

            <path class="form-checkbox-check" d="M5.778,13.959a1.107,1.107,0,0,0,1.6,0l8.013-8.013a1.133,1.133,0,1,0-1.6-1.6L6.579,11.555,3.946,8.922a1.107,1.107,0,0,0-1.6,0,1.107,1.107,0,0,0,0,1.6Z" transform="translate(3 3)" />
        </svg>

        <span>
            <slot />
        </span>
    </label>

</template>

<script>
export default {
    props: {
        modelValue: {},
    },

    data() {
        return {
            model: this.modelValue,
        };
    },

    watch: {
        modelValue(value) {
            this.model = value;
        },
    },

    emits: ['update:modelValue'],
};
</script>
